import React from 'react';
import styles from '../../styles/match-event-placeholders.module.scss'
import classNames from "classnames";

export const MatchEventModulePlaceholderTabs = () => {
  return (
    <div className={classNames(styles.tabs)}>
      <div className={classNames(styles.tab)}/>
      <div className={classNames(styles.tab_divider)}/>
      <div className={classNames(styles.tab)}/>
    </div>
  )
};
